import type { GameState } from '../../engine/game-state.js';
import { createLayout, rowAbove } from '../../render/three/layout.js';
import type { GameSpec } from '../../render/three/game-app.js';
import { FOUNDATION_IDS, TABLEAU_IDS, yukonRules } from './rules.js';

const TABLEAU_Z = 0.0;
const TOP_Z = rowAbove(TABLEAU_Z);

// 7 columns. Foundations sit on the right of the top row (Klondike-familiar);
// Yukon has no stock/waste, so the top-left simply stays clear.
const layout = createLayout({
  cols: 7,
  rows: [
    { z: TOP_Z, slots: [null, null, null, ...FOUNDATION_IDS] },
    { z: TABLEAU_Z, fanDown: true, slots: [...TABLEAU_IDS] },
  ],
});

function dragStackIds(state: GameState, cardId: string): string[] {
  for (const pile of Object.values(state.piles)) {
    const idx = pile.cards.findIndex((c) => c.id === cardId);
    if (idx === -1) continue;
    const head = pile.cards[idx]!;
    if (!head.faceUp) return [];
    if (pile.type !== 'tableau') {
      // foundation: only the top card is grabbable
      if (idx !== pile.cards.length - 1) return [];
      return [cardId];
    }
    // Yukon: grab this card plus everything stacked on it - no sequence check.
    return pile.cards.slice(idx).map((c) => c.id);
  }
  return [];
}

export const yukonSpec: GameSpec = {
  rules: yukonRules,
  slotForPile: (id) => layout.slot(id),
  dropExclude: () => [],
  dragStackIds,
  autoSendOrder: () => [...FOUNDATION_IDS, ...TABLEAU_IDS],
  // Columns start as deep as 11 and grow as unsorted groups pile on; give the
  // camera/felt room for a realistic worst case (~19, as in classic Klondike).
  maxFanLength: 19,
  statusText(state) {
    if (yukonRules.isLost!(state)) return 'No moves left';
    return null;
  },
};
